(function (m, o, v, a, b, l, e) {
  if (typeof m['MovableInkTrack'] !== 'undefined') { return; }
  m['MovableInkTrack'] = b;
  l = o.createElement(v);
  e = o.getElementsByTagName(v)[0];
  l.type = 'text/javascript'; l.async = true;
  l.src = '//' + a + '/p/js/1.js';
  m[b] = m[b] || function () { (m[b].q = m[b].q || []).push(arguments); };
  e.parentNode.insertBefore(l, e);

  /* Exclusively for Darwin&#39;s Natural Pet Products */
})(window, document, 'script', '19iv8tzd.micpn.com', 'mitr');